import React, { useState, useEffect, useRef } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Modal } from 'bootstrap';
import { useNavigate } from "react-router-dom";
import clientHttp from '../../components/ClientHttp';
import { formatDateTime } from '../../components/DateUtil';
import MagicEOMList from './MagicEOMList'

export default function MagicEOMReconcileContent() {
    const currentDate = new Date();
    const [fromDate, setFromDate] = useState(new Date(currentDate.getFullYear(), currentDate.getMonth(), 2));
    const [toDate, setToDate] = useState(new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate())); //useState(currentDate);
    const [filter, setFilter] = useState('A')
    const [data, setData] = useState(null);
    const [error, setError] = useState('');
    const [errorClass, setErrorClass] = useState('');
    const [isSearchLoading, setIsSearchLoading] = useState(false)

    // import magic file
    const [orderDate, setOrderDate] = useState(new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate())); //useState(currentDate);
    const [selectedFile, setSelectedFile] = useState(null)
    const [selectedFileData, setSelectedFileData] = useState(null)
    const [selectedFilename, setSelectedFilename] = useState(null)
    const importMagicFileRef = useRef()
    const [errorMessageClass, setErrorMessageClass] = useState('')
    const [errorMessage, setErrorMessage] = useState('')
    const [orderSuccessRow, setOrderSuccessRow] = useState(0)
    const [orderFailedRow, setOrderFailedRow] = useState(0)
    const [isUploadCompleted, setIsUploadCompleted] = useState(false)
    const [isLoading, setIsLoading] = useState(false)

    let navigate = useNavigate()

    let datePast = parseInt(process.env.REACT_APP_ORDERPAYMENT_DATEPAST)
    console.log('datePast: ' + datePast)
    //const [minDate, setMinDate] = useState(new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()));
    //const [maxDate, setMaxDate] = useState(new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() + datePast));

    // change page
    const onDateChange = (newDate) => {
        console.log('select from date: ' + newDate)
        setFromDate(newDate)
        setToDate(newDate)
        //setToDate(new Date(newDate.getFullYear(), newDate.getMonth(), newDate.getDate()+1))
        //setMinDate(newDate)
        //setMaxDate(new Date(newDate.getFullYear(), newDate.getMonth(), newDate.getDate() + datePast))
    };

    // DatePicker
    const fromDateCalendar = useRef(null)
    const toDateCalendar = useRef(null)
    const importMagicCalendar = useRef(null)
    async function openFromDateCalendar() { fromDateCalendar.current.setFocus(true); }
    async function openToDateCalendar() { toDateCalendar.current.setFocus(true); }
    async function openImportMagicCalendar() { importMagicCalendar.current.setFocus(true); }

    // dropdown list
    const selectFilter = (e) => { setFilter(e.target.value) }

    async function searchSubmit() {
        setIsSearchLoading(true)
        let isSuccess = false
        // clear data
        setError('')
        setErrorClass('')
        setData(null)

        console.log('call search api with parameters:' + fromDate, toDate)
        const _fromDate = fromDate.getFullYear() + '-' + (fromDate.getMonth() + 1) + '-' + fromDate.getDate();
        const toDate2 = new Date(toDate)
        toDate2.setDate(toDate2.getDate()+1)
        const _toDate = toDate2.getFullYear() + '-' + (toDate2.getMonth() + 1) + '-' + toDate2.getDate();
        const formData = {
            fromDate: _fromDate,
            toDate: _toDate,
            filter: filter
        }
        console.log(formData)
        let token = localStorage.getItem('token')
        await clientHttp.post('report/v1/magiceomreconcile', formData, {
            headers: { 'Authorization': 'Bearer ' + token }
        })
            .then(response => {
                console.log('response status: ' + response.status)
                if (response.data.status === 'success') {
                    console.log('display magic eom list')
                    setData(response.data.data)
                    //console.log(response)
                    isSuccess = true
                    setErrorClass('text-black')
                } else {
                    console.log('get magic eom list failed: ' + response.data.message)
                    setError(response.data.message)
                    setErrorClass('text-danger')
                }

            }).catch(err => {
                console.log('error: ', err.message)
                if (err.response.status === 401 || err.response.status === 403) {
                    console.log('no authorize, redirect to login page')
                    navigate(process.env.REACT_APP_LOGIN_URI)
                } else {
                    console.log('get magic eom list failed: ' + err.message)
                    setError(err.message)
                    setErrorClass('text-danger')
                }
            })

        if (!isSuccess) {
            let errorMessageModal = new Modal('#errorMessageModal')
            errorMessageModal.show()
        }
        setIsSearchLoading(false)
    }

    // On file select (from the pop up)
    const onFileChange = (event) => {
        const file = event.target.files[0]
        setSelectedFile(file)
        setErrorMessage('')

        if (file) {
            setSelectedFilename(file.name);
            const reader = new FileReader();

            reader.onload = (e) => {
                let base64 = e.target.result.split(',')
                setSelectedFileData(base64[1]); // The Base64 string
            };

            reader.onerror = (error) => {
                console.error("Error reading file:", error)
                setSelectedFile(null)
                setSelectedFileData(null)
                setSelectedFilename(null)
                setErrorMessage('Read file error')
            };

            reader.readAsDataURL(file); // Start reading the file as Base64'
        } else {
            setSelectedFile(null)
            setSelectedFileData(null)
            setSelectedFilename(null)
            setErrorMessage('No file')
        }

    }
    // On file upload (click the upload button)
    async function onFileUpload() {
        setIsUploadCompleted(false)
        setIsLoading(true)
        setErrorMessageClass('text-danger')
        setErrorMessage('')
        setOrderSuccessRow(0)
        setOrderFailedRow(0)

        // check user has selected file
        if (!selectedFile) {
            setIsLoading(false)
            setErrorMessage('No Bank file is selected!')
            return
        }

        // Create an object of formData
        console.log('call search api with parameters:' + orderDate)
        const _orderDate = orderDate.getFullYear() + '-' + (orderDate.getMonth() + 1) + '-' + orderDate.getDate();
        const formData = {
            orderDate: _orderDate,
            user: localStorage.getItem('name'),
            filename: selectedFilename,
            fileData: selectedFileData
        }

        // Details of the uploaded file
        //console.log(selectedFile);
        console.log('Selected file: ' + selectedFilename)
        //console.log('Selected file data: ' + selectedFileData)
        //console.log(formData)

        // Request made to the backend api
        // Send formData object
        let token = localStorage.getItem('token')
        try {
            await clientHttp.post(process.env.REACT_APP_BASE_URL + "report/v1/upload_magicfile", formData, {
                timeout: 900000, // 15 mins for this specific request,
                headers: {
                    'Authorization': 'Bearer ' + token
                    //'Content-Type': 'multipart/form-data'
                }
            }).then(response => {
                console.log('response status: ' + JSON.stringify(response.data))
                if (response.data.status === 'success') {
                    setErrorMessageClass('text-success')
                    setOrderSuccessRow(response.data.orderSuccess)
                    setOrderFailedRow(response.data.orderFailed)
                }
                console.log('orderSuccessRow: ' + orderSuccessRow + ', orderFailedRow: ' + orderFailedRow)

                setErrorMessage(response.data.message)
                setIsUploadCompleted(true)
            }).catch(error => {
                if (error.response.status === 401 || error.response.status === 403) {
                    console.log('no authorize, redirect to login page')
                    navigate(process.env.REACT_APP_LOGIN_URI)
                } else {
                    console.log('get upload bank file failed: ' + error.message)
                    setErrorMessage(error.message)
                }
                setIsUploadCompleted(true)
            })
        } catch (err) {
            console.log('get upload bank file failed: ' + err.message)
            setErrorMessage(err.message)
            setIsUploadCompleted(true)
        }

        //await new Promise( res => setTimeout(res, 1000) );
        setIsLoading(false)
    }

    async function importMagic() {
        console.log('selected bank: ')
        setSelectedFile(null)
        setSelectedFileData(null)
        setSelectedFilename(null)
        setErrorMessage('')
        setIsUploadCompleted(false)
        setOrderSuccessRow(0)
        setOrderFailedRow(0)
        importMagicFileRef.current.value = ''
        let importMagicFileForm = new Modal('#importMagicFileForm')
        importMagicFileForm.show()
    }

    useEffect(() => {
        // first enter then call search with current month
        //searchSubmit()
    }, [])

    return (
        <>
            <div className="page-header">
            </div>
            <div className="row">
                <div className="col-md-12">
                    {/* start form */}
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                    <div className="form-group">
                                        <div className="input-group ">
                                            <span className="input-group-text">From Date:</span>
                                            <DatePicker className="form-control" ref={fromDateCalendar} selected={fromDate} onChange={onDateChange} dateFormat="dd/MM/yyyy" />
                                            <span className="input-group-text" onClick={openFromDateCalendar.bind(this)}><i className="bi bi-calendar-date"></i></span>

                                            <span className="input-group-text ms-3">To Date:</span>
                                            <DatePicker className="form-control" ref={toDateCalendar} selected={toDate} onChange={(date) => setToDate(date)} dateFormat="dd/MM/yyyy" />
                                            <span className="input-group-text" onClick={openToDateCalendar.bind(this)}><i className="bi bi-calendar-date"></i></span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                    <div className="form-group">
                                        {isSearchLoading ?
                                            <button className="btn btn-black btn-border btn-primary" style={{ "width": "120px" }} type="button">
                                                <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                                <span role="status" className="ms-3">Loading...</span>
                                            </button>
                                            :
                                            <button type="button" className="btn btn-primary" style={{ "width": "120px" }} onClick={searchSubmit.bind(this)}>
                                                <i className="bi bi-search me-2"></i> Search
                                            </button>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12">
                                    <div className="form-group">
                                        <div className="input-group ">
                                            <span className="input-group-text">Type:</span>
                                            <select className="form-select" value={filter} onChange={selectFilter}>
                                                <option value="A">All</option>
                                                <option value="S">No order generated</option>
                                                <option value="O">More than 1 order generated</option>
                                                <option value="M">Normal</option>
                                                <option value="N">Abnormal</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                    <div className="form-group">
                                        <div className="input-group ">
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                    <div className="form-group">
                                        <button type="button" className="btn btn-black btn-border" style={{ "width": "150px" }} onClick={importMagic.bind(this)}>
                                            <i className="bi bi-arrow-down-right-circle me-2"></i> Import Magic
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* end form */}
                </div>
            </div>

            <div className="row">
                <div className="col-md-12">
                    <MagicEOMList data={data} />
                </div>
            </div>

            <div className='row'>
                <div className='col-md-12'>
                    <div className="modal fade" id="errorMessageModal" tabIndex="-1" >
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-body">
                                    <p className={errorClass}>{error}</p>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="importMagicFileForm" tabIndex="-1" aria-labelledby="importMaginFileLabel">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <form>
                                <div className="mb-2 row">
                                    <label htmlFor="staticOrderId" className="col-sm-3 col-form-label">Order Date :</label>
                                    <div className="col-sm-9 col-form-label">
                                        <DatePicker className="form-control" ref={importMagicCalendar} selected={orderDate} onChange={(date) => setOrderDate(date)} dateFormat="dd/MM/yyyy" />
                                    </div>
                                </div>
                                <div className="mb-2">
                                    <label htmlFor="formFile" className="form-label">Magic file to import</label>
                                    <input ref={importMagicFileRef} className="form-control" type="file" id="importMagicFile" onChange={onFileChange.bind(this)} />
                                </div>
                                {selectedFile &&
                                    <div className="p-2 bg-body-secondary rounded">
                                        <div className="row">
                                            <label htmlFor="staticSelectedFileType" className="col-sm-3 col-form-label">Type :</label>
                                            <div className="col-sm-9">
                                                <input type="text" readOnly className="form-control-plaintext" id="staticSelectedFileType" value={selectedFile.type} />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <label htmlFor="staticSelectedFileLastModified" className="col-sm-3 col-form-label">Last modified :</label>
                                            <div className="col-sm-9">
                                                <input type="text" readOnly className="form-control-plaintext" id="staticSelectedFileLastModified" value={formatDateTime(selectedFile.lastModifiedDate)} />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <label htmlFor="staticSelectedFileSize" className="col-sm-3 col-form-label">Size :</label>
                                            <div className="col-sm-9">
                                                <input type="text" readOnly className="form-control-plaintext" id="staticSelectedFileSize" value={selectedFile.size < 1000 ? selectedFile.size : Math.round(selectedFile.size / 1000) + "KB"} />
                                            </div>
                                        </div>
                                    </div>
                                }
                            </form>
                            <div className="mb-3">
                                <p className="mt-4 mb-6 text-sm">
                                    <span className={errorMessageClass}>{errorMessage}</span>
                                    <><br /><span className="text-success">Total rows: {orderSuccessRow}</span> <span className="ms-2 text-danger"></span></>
                                </p>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-dark" data-bs-dismiss="modal" >Close</button>
                            {isLoading ?
                                <button className="btn btn-primary" style={{ width: '120px' }} type="button">
                                    <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                    <span role="status" className="ms-3">Upload</span>
                                </button>
                                : !isUploadCompleted &&
                                <button type="button" className="btn btn-primary" style={{ width: '120px' }} onClick={onFileUpload.bind(this)}>
                                    <i className="bi bi-upload me-2"></i> Upload
                                </button>
                            }
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}